module.exports = __webpack_public_path__ + "static/media/SF_bm_primaerlogo_vestfold_telemark_pos.0e971c50.svg";